<template>
  <!-- w-36 h-36 -->
  <path
    d='M3.75 18C3.75 10.1299 10.1299 3.75 18 3.75C25.8701 3.75 32.25 10.1299 32.25 18C32.25 25.8701 25.8701 32.25 18 32.25C10.1299 32.25 3.75 25.8701 3.75 18Z'
    stroke='#2AAB6D' stroke-width='1.5' />
  <path d='M11 19L15.5 23.5L25 13' stroke='#2AAB6D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
</template>
